import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';

import Tasks from '@/routes/Tasks.vue';
import Migrate from '@/routes/Migrate.vue';
import Connections from '@/components/Connections.vue';
import SourceQueries from '@/components/SourceQueries.vue';
import Summary from '@/components/Summary.vue';
import Transform from '@/components/Transform.vue';

// import Postman from '@/routes/Postman.vue';
import Fields from '@/routes/Fields.vue';
import AisonApplicationConfiguration from '@/components/generators/AisonApplicationConfiguration.vue';

const routes: RouteRecordRaw[] = [
  { path: '/tasks', component: Tasks },
  {
    path: '/migrate',
    component: Migrate,
    children: [
      { path: 'connections', component: Connections },
      { path: 'queries', component: SourceQueries },
      { path: 'transform', component: Transform },
      { path: 'summary', component: Summary },
    ],
  },
  // { path: '/postman', component: Postman },
  {
    path: '/fields',
    component: Fields,
    children: [
      { path: 'connections', component: Connections },
      { path: 'application', component: AisonApplicationConfiguration },
    ],
  },
  { path: '/', redirect: '/migrate/connections' },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
